// extracted by mini-css-extract-plugin
export default {"Bluecheese":"#615CFF","cta":"Gcdb3d4","tooltip":"Gc8e264","cta__icon":"Gc691f2"};